export function generateWeeklySchedule(groups, groupSettings) {
  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
  const sessionMinutes = groupSettings.sessionMinutes;

  return days.map((day, dayIndex) => {
    const sessions = [];
    groups.forEach((group, groupIndex) => {
      sessions.push({
        group: `Group ${groupIndex + 1}: ${group.skillFocus}`
      });
    });

    return {
      day,
      sessions
    };
  });
}

export function generateNextSteps() {
  return [
    'Pull decodables from matched Scope & Sequence units for each group',
    'Set up materials and activities for first week of instruction',
    'Track student progress after each session using observation notes',
    'Plan assessment checkpoints every 2 weeks to monitor skill mastery',
    'Reassess and regroup students every 4-6 weeks or when skills are mastered',
    'Celebrate student progress and adjust instruction based on data'
  ];
}